import { merge, Stack, StackItem, Text } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import React, { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import burgerIcon from '../../../assets/icons/svg/burger.svg';
import closeIcon from '../../../assets/icons/svg/close.svg';
import offIcon from '../../../assets/icons/svg/off.svg';
import userIcon from '../../../assets/icons/svg/user.svg';
import { useAuthManager } from '../../../contexts/authContext';
import { ResponsiveSize, useResponsiveSize } from '../../../contexts/responsiveContext';
import { useUser } from '../../../contexts/userContext';
import SvgIcon from '../../SvgIcon';
import Menu from './Menu';

const UserMenu = () => {

    const { disconnect } = useAuthManager();
    const { responsiveSize } = useResponsiveSize();
    const { user } = useUser();
    const location = useLocation();
    const navigate = useNavigate();

    const [isMenuOpen, { setTrue: showMenu, setFalse: hideMenu }] = useBoolean(false);

    const isActive = useMemo(() => {
        return location.pathname === "/monprofil";
    }, [location.pathname]);

    const styles = useMemo(
        () => {
            let styles = {
                fullname: {
                    root: { marginBottom: 14 }
                },
                fullnameContainer: {
                    root: { borderBottom: isActive ? "2px solid red" : "none" }
                },
                iconButton: {
                    root: { height: "unset" },
                    icon: {
                        alignSelf: "flex-end",
                        height: "unset"
                    }
                },
                icons: {
                    root: {
                        gap: 16,
                        paddingBottom: 21
                    }
                },
                icon: {
                    root: {
                        cursor: "pointer",
                        height: "unset",
                        overflow: "visible",
                    },
                    image: { width: 24 }
                },
                outer: {
                    root: {
                        gap: 16,
                        paddingRight: 26,
                    }
                },
                userName: {
                    root: {
                        fontWeight: 600,
                        fontSize: 16,
                        lineHeight: "19px",
                    }
                },
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(
                    styles,
                    {
                        outer: {
                            root: {
                                gap: 22,
                                minWidth: 360
                            }
                        },
                    }
                );

            return styles;
        },
        [isActive, responsiveSize]
    );

    const goToProfile = useCallback(() => {
        navigate("/monprofil");
    }, [navigate]);

    if (responsiveSize === ResponsiveSize.small)
        return <Stack horizontal verticalAlign="end" styles={styles.outer}>
            <Stack horizontal styles={styles.icons}>
                <SvgIcon onClick={goToProfile} src={userIcon} title="Afficher le profil" />
                {isMenuOpen
                    ? <SvgIcon onClick={hideMenu} src={closeIcon} title="Masquer le menu" />
                    : <SvgIcon onClick={showMenu} src={burgerIcon} title="Afficher le menu" />
                }
            </Stack>
            <Menu isOpen={isMenuOpen} onChange={hideMenu} />
        </Stack>;

    else return <Stack horizontal verticalAlign="end" styles={styles.outer}>
        <StackItem styles={styles.fullnameContainer} grow>
            <Stack horizontalAlign="end" styles={styles.fullname}>
                <Text styles={styles.userName}>{user.prenom}</Text>
                <Text styles={styles.userName}>{user.nom.toUpperCase()}</Text>
            </Stack>
        </StackItem>
        <Stack horizontal styles={styles.icons}>
            <SvgIcon id="btnProfile" onClick={goToProfile} src={userIcon} title="Afficher le profil" />
            <SvgIcon id="btnLogOut" onClick={disconnect} src={offIcon} title="Déconnexion" />
        </Stack>
    </Stack>;

};

export default UserMenu;